import { 
  Heart, 
  Brain, 
  Baby, 
  Bone, 
  Eye, 
  Stethoscope,
} from "lucide-react";

export const services = [
  {
    icon: Heart,
    title: "Cardiology",
    description: "Comprehensive heart care with advanced cardiac procedures and preventive treatments.",
    available: "24/7"
  },
  {
    icon: Brain,
    title: "Neurology",
    description: "Expert neurological care for brain, spine, and nervous system conditions.",
    available: "Mon-Fri"
  },
  {
    icon: Baby,
    title: "Pediatrics",
    description: "Specialized medical care for infants, children, and adolescents.",
    available: "24/7"
  },
  {
    icon: Bone,
    title: "Orthopedics",
    description: "Advanced treatment for bone, joint, and musculoskeletal disorders.",
    available: "Mon-Sat"
  },
  {
    icon: Eye,
    title: "Ophthalmology",
    description: "Complete eye care services from routine exams to complex surgeries.",
    available: "Mon-Fri"
  },
  {
    icon: Stethoscope,
    title: "General Medicine",
    description: "Primary healthcare services and preventive medicine for all ages.",
    available: "24/7"
  }
];
